/**
 * GYLT Cart Drawer & AJAX Handler
 */
console.log('GYLT Cart Drawer Script Loaded');
class GyltCartDrawer {
    constructor() {
        this.selectors = {
            drawer: '#cart-drawer',
            backdrop: '#cart-drawer-backdrop',
            panel: '#cart-drawer-panel',
            itemsContainer: '#cart-drawer-items',
            closeBtn: '#cart-drawer-close',
            trigger: '.js-cart-drawer-trigger',
            subtotal: '#cart-drawer-subtotal',
            countBubbles: '[data-cart-count]',
            forms: '[data-ajax-cart-form]'
        };

        this.drawer = document.querySelector(this.selectors.drawer);
        this.backdrop = document.querySelector(this.selectors.backdrop);
        this.panel = document.querySelector(this.selectors.panel);
        this.itemsContainer = document.querySelector(this.selectors.itemsContainer);

        this.init();
    }

    init() {
        console.log('GYLT Cart Drawer Initialized');
        if (!this.drawer) return;

        // Event Listeners
        document.addEventListener('click', (e) => {
            // Toggle Trigger
            // Toggle Trigger
            if (e.target.closest(this.selectors.trigger)) {
                e.preventDefault();
                this.open();
            }

            // Close Button
            if (e.target.closest(this.selectors.closeBtn)) {
                this.close();
            }

            // Backdrop Click
            if (e.target === this.backdrop) {
                this.close();
            }

            // Quantity Buttons
            if (e.target.closest('[data-qty-action]')) {
                const btn = e.target.closest('[data-qty-action]');
                this.updateQuantity(btn.dataset.key, btn.dataset.qtyAction === 'plus' ? 1 : -1, btn);
            }

            // Remove Button
            if (e.target.closest('[data-remove-item]')) {
                const btn = e.target.closest('[data-remove-item]');
                this.updateQuantity(btn.dataset.key, 0, null, true); // 0 delta implies removal call
            }
        });

        // Add to Cart Forms
        document.addEventListener('submit', (e) => {
            const form = e.target.closest(this.selectors.forms);
            if (form) {
                e.preventDefault();
                this.addToCart(form);
            }
        });

        // Escape Key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !this.drawer.classList.contains('invisible')) {
                this.close();
            }
        });
    }

    open() {
        try {
            // alert('Open called');
            this.fetchCart();

            if (!this.drawer) { alert('Drawer is null'); return; }

            this.drawer.classList.remove('invisible');
            // alert('Removed invisible');

            document.body.style.overflow = 'hidden';

            // Animate in
            setTimeout(() => {
                // alert('Timeout running');
                if (this.backdrop) this.backdrop.classList.remove('opacity-0');
                if (this.panel) this.panel.classList.remove('translate-x-full');
            }, 10);

        } catch (e) {
            alert('Error in open(): ' + e.message);
            console.error(e);
        }
    }

    close() {
        if (this.backdrop) this.backdrop.classList.add('opacity-0');
        if (this.panel) this.panel.classList.add('translate-x-full');

        setTimeout(() => {
            if (this.drawer) this.drawer.classList.add('invisible');
            document.body.style.overflow = '';
        }, 300);
    }

    addToCart(form) {
        const submitBtn = form.querySelector('[type="submit"]');
        const originalText = submitBtn.innerHTML;

        // Loading State
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span class="animate-spin inline-block h-4 w-4 border-2 border-white/20 border-t-white rounded-full"></span>';

        const formData = new FormData(form);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(item => {
                // Basic Error handling
                if (item.status === 422) {
                    alert(item.description);
                    return;
                }

                this.fetchCart(); // Update drawer
                this.open(); // Open drawer
            })
            .catch(err => console.error(err))
            .finally(() => {
                submitBtn.disabled = false;
                submitBtn.innerHTML = originalText;
            });
    }

    fetchCart() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                this.renderItems(cart);
                this.updateHeaderCount(cart.item_count);
            });
    }

    updateQuantity(key, delta, btn, isRemove = false) {
        // If removing, set line to 0. If updating, we need current qty.
        // Simplifying: we'll use /cart/change.js which takes 'id' (or line) and 'quantity'.
        // Since we don't have current qty easily without DOM, we can rely on bubble or re-fetch, 
        // BUT easier: /cart/change.js?id=key&quantity=new_qty.
        // OR we can use the 'updates' object: { [id]: new_qty } -> /cart/update.js

        // BETTER: Find the input in the item row to get current value
        let newQty = 0;

        if (!isRemove) {
            // Find the input relative to the button
            const row = btn.closest('.cart-item-row');
            const input = row.querySelector('input[type="number"]');
            const currentQty = parseInt(input.value);
            newQty = currentQty + delta;
        }

        const payload = {
            id: key,
            quantity: newQty
        };

        // Optimistic UI update (optional, skipping for safety)

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
            .then(res => res.json())
            .then(cart => {
                this.renderItems(cart);
                this.updateHeaderCount(cart.item_count);
            });
    }

    renderItems(cart) {
        if (!this.itemsContainer) {
            console.error('Error: Items Container Not Found in JS');
            return;
        }

        const container = this.itemsContainer;
        const subtotalEl = document.querySelector(this.selectors.subtotal);

        if (cart.item_count === 0) {
            container.innerHTML = `
        <div class="flex flex-col items-center justify-center h-full text-center text-gray-500">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mb-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          </svg>
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="mt-4 text-blue-600 font-medium hover:underline" onclick="document.querySelector('#cart-drawer-close').click()">Start Shopping</a>
        </div>
      `;
            subtotalEl.textContent = this.formatMoney(0);
            return;
        }

        // Build HTML
        let html = '';
        cart.items.forEach(item => {
            const imageHtml = item.image
                ? `<img src="${item.image}" alt="${item.product_title}" class="w-full h-full object-cover">`
                : `<div class="w-full h-full bg-gray-100 flex items-center justify-center text-gray-300"><svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg></div>`;

            const variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
                ? `<p class="text-xs text-gray-500 mt-1">${item.variant_title}</p>`
                : '';

            html += `
        <div class="cart-item-row flex gap-4 py-4 border-b border-gray-100" data-key="${item.key}">
          <!-- Image -->
          <div class="relative w-24 h-24 flex-shrink-0 bg-gray-100 rounded-lg overflow-hidden border border-gray-200">
            ${imageHtml}
          </div>

          <!-- Info -->
          <div class="flex-1 flex flex-col justify-between py-1">
            <div>
              <h3 class="text-sm font-bold text-gray-900 leading-tight">
                <a href="${item.url}" class="hover:text-blue-600 transition-colors">${item.product_title}</a>
              </h3>
              ${variantHtml}
            </div>

            <div class="flex items-end justify-between mt-3">
              <!-- Qty Control -->
              <div class="flex items-center border border-gray-300 rounded-md h-8">
                <button type="button" class="w-8 h-full flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50 rounded-l-md transition" data-qty-action="minus" data-key="${item.key}">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
                <input type="number" readonly value="${item.quantity}" class="w-8 h-full text-center border-none p-0 text-xs font-semibold text-gray-900 focus:ring-0 bg-transparent">
                <button type="button" class="w-8 h-full flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50 rounded-r-md transition" data-qty-action="plus" data-key="${item.key}">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
              </div>
              
              <div class="flex flex-col items-end">
                <span class="text-sm font-bold text-gray-900">${this.formatMoney(item.final_line_price)}</span>
                 <button type="button" class="text-[10px] text-gray-400 hover:text-red-500 underline mt-1 transition-colors" data-remove-item data-key="${item.key}">
                    Remove
                 </button>
              </div>
            </div>
          </div>
        </div>
      `;
        });

        container.innerHTML = html;
        subtotalEl.textContent = this.formatMoney(cart.total_price);
    }

    updateHeaderCount(count) {
        const bubbles = document.querySelectorAll(this.selectors.countBubbles);
        bubbles.forEach(b => {
            b.textContent = count;
            if (count > 0) b.classList.remove('hidden');
            else b.classList.add('hidden');
        });
    }

    formatMoney(cents) {
        let value = (cents / 100).toFixed(2);
        if (window.shopCurrencyFormat) {
            return window.shopCurrencyFormat.replace('{{amount}}', value);
        }
        return '$' + value;
    }
}

// Init when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new GyltCartDrawer());
} else {
    new GyltCartDrawer();
}
